import { TEMPLATE_HINTS, TEMPLATE_LABELS, type TemplateName } from '@/lib/types'

interface Props {
  value: TemplateName
  onChange: (next: TemplateName) => void
}

/**
 * Templates grouped by motion. Native <optgroup> renders as a section header
 * inside the dropdown — keeps the picker scannable as the catalog grows.
 */
const GROUPS: { label: string; templates: TemplateName[] }[] = [
  {
    label: 'Sales — by stage',
    templates: ['sales-discovery', 'sales-followup'],
  },
  {
    label: 'Sales — by vertical',
    templates: [
      'sales-fintech',
      'sales-banking',
      'sales-private-market',
      'sales-ai-solutions',
    ],
  },
  {
    label: 'Marketing',
    templates: ['marketing-customer-interview', 'marketing-campaign-planning'],
  },
  {
    label: 'Finance',
    templates: ['finance-budget-review'],
  },
  {
    label: 'Other',
    templates: ['generic'],
  },
]

export function TemplatePicker({ value, onChange }: Props) {
  return (
    <div className="px-3 pt-3">
      <label className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-zinc-500">
        Template
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as TemplateName)}
        className="w-full rounded border border-zinc-300 bg-white px-2 py-1.5 text-sm text-zinc-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        {GROUPS.map((g) => (
          <optgroup key={g.label} label={g.label}>
            {g.templates.map((t) => (
              <option key={t} value={t}>
                {TEMPLATE_LABELS[t]}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      <p className="mt-1 text-[11px] text-zinc-500">{TEMPLATE_HINTS[value]}</p>
    </div>
  )
}
